export default "__VITE_ASSET__cd8e77d7__"